import React from 'react'
import PropTypes from 'prop-types'
import Spinner from 'react-spinkit'
import constants from '../../../lib/constants'
import Watch from 'react-feather/dist/icons/watch.js'
import BookOpen from 'react-feather/dist/icons/book-open.js'
import Upload from 'react-feather/dist/icons/upload-cloud.js'
import Database from 'react-feather/dist/icons/database.js'
import AlertCircle from 'react-feather/dist/icons/alert-circle.js'
import './ResultModal.scss'
import * as _ from 'lodash'

class ResultModal extends React.Component {
  static propTypes = {
    job: PropTypes.shape({
      status: PropTypes.number,
      error_message: PropTypes.string,
      wbc_count: PropTypes.number,
      neutrophils: PropTypes.number
    })
  }

  static defaultProps = {
    job: null
  }

  render () {
    const { job } = this.props
    let modalBody = null
    if (job) {
      if (!job.status) {
        if (job.job_status === constants.JOB_STATUSES.QUEUED) {
          modalBody = (
            <div>
              <div>
                Your test is queued. Waiting for the device to start.
              </div>
              <div className='state-icon-container'>
                <Watch size={50} strokeWidth={1.5} />
              </div>
            </div>
          )
        } else if (job.job_status === constants.JOB_STATUSES.IMAGING) {
          modalBody = (
            <div>
              <div>
                The device is currently reading the test strip.
              </div>
              <div className='state-icon-container'>
                <BookOpen size={50} strokeWidth={1.5} />
              </div>
            </div>
          )
        } else if (job.job_status === constants.JOB_STATUSES.UPLOADING) {
          modalBody = (
            <div>
              <div>
                The device is uploading its analysis. If this takes more than a few minutes please check your network speed.
              </div>
              <div className='state-icon-container'>
                <Upload size={50} strokeWidth={1.5} />
              </div>
            </div>
          )
        } else if (job.job_status === constants.JOB_STATUSES.PROCESSING) {
          modalBody = (
            <div>
              <div>
                The Athelas server is analyzing the results. Your results will return shortly.
              </div>
              <div className='state-icon-container'>
                <Database size={50} strokeWidth={1.5} />
              </div>
            </div>
          )
        } else if (job.job_status === constants.JOB_STATUSES.FAILED) {
          modalBody = (
            <div>
              <div className='alert alert-warning' role='alert'>
                Sorry something went wrong! Please try starting a new test. We are investigating the issue.
                Please <a href='mailto:support@athelas.com'>email us</a> if you'd like to provide more information.
              </div>
              <div className='state-icon-container'>
                <AlertCircle size={50} strokeWidth={1.5} />
              </div>
            </div>
          )
        }
      } else {
        modalBody = (
          <div className='table-responsive'>
            <table className='table'>
              <thead>
                <tr scope='col'>
                  <th>Parameter</th>
                  <th>Value</th>
                </tr>
              </thead>
              {
                job.error_message ? (
                  <tbody>
                    <tr>
                      <td scope='row'>Error</td>
                      <td>{job.error_message}</td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td scope='row'>WBC</td>
                      <td>{Number(job.wbc_count.toFixed(1))} K/µL</td>
                    </tr>
                    <tr>
                      <td scope='row'>Neutrophils</td>
                      <td>{Number(job.neutrophils.toFixed(0))} %</td>
                    </tr>
                    <tr>
                      <td scope='row'>ANC</td>
                      <td>{Number(job.neutrophils * job.wbc_count / 100).toFixed(1)} K/µL</td>
                    </tr>
                  </tbody>
                )
              }
            </table>
          </div>
        )
      }
    } else {
      modalBody = (
        <div>
          <div>
            <div>
              Your results are loading. Please wait 5 minutes for the test to finish.
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', margin: 50 }}>
              <Spinner name='double-bounce' color='red' />
            </div>
          </div>
        </div>  
      )
    }

    return (
      <div className='modal' id='resultModal' tabIndex='-1' role='dialog'>
        <div className='modal-dialog' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Results
                { job && job.note ? <span> for {job.note}</span> : null }
              </h5>
              <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              {modalBody}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ResultModal



// WEBPACK FOOTER //
// ./src/routes/Home/components/ResultModal.js